import { render, staticRenderFns } from "./common_new.vue?vue&type=template&id=4c1281ec"
import script from "./common_new.vue?vue&type=script&lang=js"
export * from "./common_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports